import { Controller } from '@hotwired/stimulus'

import toastr from '../src/init/toastr'

// Connects to data-controller="curo-connect-form"
export default class extends Controller {
  static targets = ['output']
  static classes = ['error']
  static values = {
    accessToken: String,
    successMessage: String
  }

  async submit (event) {
    event.preventDefault()

    try {
      const formData = new FormData(this.element)
      const method = this.element.method

      fetch(this.element.action, {
        method,
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${this.accessTokenValue}`
        },
        // GET/HEAD requests cannot carry a body
        body: method.toLowerCase() === 'get' ? undefined : formData
      }).then((response) => {
        if (response.ok) {
          toastr.success(this.successMessageValue)

          if (this.hasOutputTarget) {
            response.json().then((data) => {
              this.writeOutput(data, false)
            })
          }
        } else {
          response.json().then((data) => {
            data.errors.forEach((error) => {
              toastr.error(error.detail, error.title || error.id)
            })

            if (this.hasOutputTarget) {
              this.writeOutput(data, true)
            }
          })
        }
      })
    } catch (error) {
      console.error('Error submitting form:', error)
      toastr.error('There was an error submitting the form.')
    }
  }

  writeOutput (data, isError) {
    this.outputTarget.textContent = JSON.stringify(data, null, 2)

    // Apply error styling only when an error class is configured for this form
    this.errorClasses.forEach((errorClass) => {
      this.outputTarget.classList.toggle(errorClass, isError)
    })
  }
}
